module.exports = __webpack_public_path__ + "static/media/copy.935a56f8.svg";